import axios from "axios";

import { ISubscriptionRequestValues } from "./types";


export const extendedTariffApi = {
  postSubscriptionRequest: (values: ISubscriptionRequestValues) => {
    return axios.post(`/subscription_request/`, values)
  }
};